import { brandAssets } from './brandAssets.js';

type Variant = 'jpg' | 'png';

interface Props {
  variant: Variant;
  /** CSS max width in px (height follows aspect ratio). */
  displayWidth: number;
  className?: string;
  loading?: 'eager' | 'lazy';
}

export function PrimaryLogo({ variant, displayWidth, className, loading = 'lazy' }: Props) {
  const src =
    variant === 'jpg'
      ? displayWidth <= 320
        ? brandAssets.primaryLogo.jpg320
        : brandAssets.primaryLogo.jpg640
      : brandAssets.primaryLogo.png640;
  const intrinsic = brandAssets.primaryLogo.intrinsic;

  return (
    <img
      className={className}
      src={src}
      alt="ScrubLedger"
      width={intrinsic}
      height={intrinsic}
      loading={loading}
      decoding="async"
      style={{ width: displayWidth, height: 'auto', maxWidth: '100%' }}
    />
  );
}
